export const FONT_SIZES = [14, 16, 20, 24, 28, 32];
export const FONT_COLORS = [
  "#3F4254",
  "#AAAAAA",
  "#0000CC",
  "#FF0000",
  "#660000",
  "#FF9900",
  "#38761D",
  "#9900FF",
  "#00FF00",
];
export const BACKGROUND_COLORS = [
  "#FFFFFF",
  "#EFEFEF",
  "#F8F8FF",
  "#F0FFFF",
  "#F0FFF0",
  "#FFF0F5",
  "#FFFACD",
  "#FFDAB9",
  "#D8BFD8",
  "#E6E6FA",
  "#AFEEEE",
  "#98FB98",
];
export const PRESETS = [
  {
    name: "Arial, черн, 16",
    styles: ["fontArial", "fontSize16", "fontColor#3F4254"],
    blockData: {},
  },
];

export const BLOCKS = [
  "unstyled",
  "nopadding",
  "header-one",
  "header-two",
  "header-three",
];

let styles = {
  ITALIC: {
    fontStyle: "italic",
  },
  BOLD: {
    fontWeight: "bold",
  },
  UNDERLINE: {
    textDecoration: "underline",
  },
  STRIKETHROUGH: {
    textDecoration: "line-through",
  },
  SUPERSCRIPT: {
    fontSize: "0.75em",
    verticalAlign: "super",
  },
  SUBSCRIPT: {
    fontSize: "0.75em",
    verticalAlign: "sub",
  },
  HIGHLIGHT: {
    backgroundColor: "#fff59d",
  },
  RIGHT: {
    textAlign: "right",
    display: "block",
  },
  LEFT: {
    textAlign: "left",
  },
  CENTER: {
    textAlign: "center",
    display: "block",
  },

  LH15: {
    lineHeight: "1.5",
  },
  LH2: {
    lineHeight: "2",
  },
  LH25: {
    lineHeight: "2.5",
  },

  fontArial: {
    fontFamily: "Arial",
  },
  fontTimes: {
    fontFamily: "Times New Roman",
  },
  fontCourier: {
    fontFamily: "Courier New",
  },
  fontComic: {
    fontFamily: "Comic Sans MS",
  },
};

FONT_SIZES.forEach((size) => {
  styles[`fontSize${size}`] = {
    fontSize: `${size}px`,
  };
});

FONT_COLORS.forEach((color) => {
  styles[`fontColor${color}`] = {
    color: `${color}`,
  };
});

export const stylemap = styles;
